import React from 'react'

const Skills: React.FC = () => {
  const skills = [
    { name: 'Unity', icon: 'devicon-unity-plain' },
    { name: 'C#', icon: 'devicon-csharp-plain' },
    { name: 'JavaScript', icon: 'devicon-javascript-plain' },
    { name: 'TypeScript', icon: 'devicon-typescript-plain' },
    { name: 'VS Code', icon: 'devicon-vscode-plain' },
    { name: 'Tailwind', icon: 'devicon-tailwindcss-plain' },
    { name: 'React', icon: 'devicon-react-original' },
    { name: 'HTML5', icon: 'devicon-html5-plain' },
    { name: 'CSS3', icon: 'devicon-css3-plain' },
    { name: 'Git', icon: 'devicon-git-plain' },
    { name: 'NestJS', icon: 'devicon-nestjs-plain' },
  ]

  return (
    <div className="h-full">
      <div className="flex flex-wrap justify-between gap-x-12 md:gap-x-12 gap-y-10">
        {skills.map((skill) => (
          <div className="flex flex-col items-center w-12 md:w-20">
            <i className={`${skill.icon} text-4xl md:text-7xl`}></i>
            <span className="text-sm md:text-base text-gray-600 text-nowrap">
              {skill.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Skills
